export default {
    state: {
      'deviceSectionSelfPhonePay': false,
      'installmentSectionPhonePayStyle': [false, false, false, false],
      'additionalServiceSectionPlanViewTr': false,

    },
    mutations: {
      'SET_SELF_PHONE_PAY': (state, viewFlag) => {
        state['deviceSectionSelfPhonePay'] = viewFlag
      },
      'SET_PHONE_PAY_STYLE': (state, viewFlagArr) => {
        state['installmentSectionPhonePayStyle'] = viewFlagArr
      },
      'SET_PLAN_VIEW_TR': (state, viewFlag) => {
        state['additionalServiceSectionPlanViewTr'] = viewFlag
      },
    },
    actions: {
      SetDevcieSectionSelfPhonePayStyle({ commit }, viewFlag) {
        commit('SET_SELF_PHONE_PAY', viewFlag)
      },
      SetInstallmentSectionPhonePayStyle({ commit }, viewFlagArr) {
        commit('SET_PHONE_PAY_STYLE', viewFlagArr)
      },
      SetAdditionalServiceSectionPlanViewTr({ commit }, viewFlag) {
        commit('SET_PLAN_VIEW_TR', viewFlag)
      }
    }
  }
  
  // this.$store.dispatch('SetMsg', '테스트 입니다.')
  // 가져올때: this.$store.state.ConnectedCar.msg
  